// import React, {
//   useMemo,
//   useEffect,
//   useState,
//   useCallback,
//   useRef,
// } from "react";

// const Emails = ({
//   emails = {
//     needs_response: [],
//     spam: [],
//     notify: [],
//     pagination: {
//       total_count: 0,
//       total_pages: 0,
//       has_more: false,
//       category_counts: {
//         needs_response: 0,
//         spam: 0,
//         notify: 0,
//       },
//     },
//   },
//   activeCategory,
//   loading,
//   error,
//   setActiveCategory,
//   onEmailSelect,
//   onCategoryChange,
//   onFetchEmails,
//   onDelete,
//   email,
//   viewingAllAccounts = false,
// }) => {
//   const [deletingId, setDeletingId] = useState(null);
//   const [localLoading, setLocalLoading] = useState(false);
//   // Add forceUpdate state to trigger re-renders
//   const [forceUpdateCounter, setForceUpdateCounter] = useState(0);
//   const loadingTimerRef = useRef(null);
//   const initialLoadRef = useRef(true);
//   const refreshTimeoutRef = useRef(null);
//   const fetchCompleteRef = useRef(false);

//   // Cached emails ref to prevent flickering during loading
//   const cachedEmailsRef = useRef(emails);

//   // Update cached ref when new emails arrive and ensure proper handling of all-accounts data
//   useEffect(() => {
//     // Only update cache if emails is not empty and has valid data
//     if (
//       emails &&
//       (emails.needs_response?.length >= 0 ||
//         emails.spam?.length >= 0 ||
//         emails.notify?.length >= 0)
//     ) {
//       // For all-accounts view, ensure we preserve account information
//       if (viewingAllAccounts) {
//         const validatedEmails = {
//           ...emails,
//           needs_response:
//             emails.needs_response?.map((email) => ({
//               ...email,
//               account: email.account || null,
//             })) || [],
//           spam:
//             emails.spam?.map((email) => ({
//               ...email,
//               account: email.account || null,
//             })) || [],
//           notify:
//             emails.notify?.map((email) => ({
//               ...email,
//               account: email.account || null,
//             })) || [],
//           pagination: emails.pagination || {
//             total_count: 0,
//             total_pages: 0,
//             has_more: false,
//             category_counts: {
//               needs_response: emails.needs_response?.length || 0,
//               spam: emails.spam?.length || 0,
//               notify: emails.notify?.length || 0,
//             },
//           },
//         };
//         cachedEmailsRef.current = validatedEmails;
//       } else {
//         cachedEmailsRef.current = {
//           ...emails,
//           pagination: emails.pagination || {
//             total_count: 0,
//             total_pages: 0,
//             has_more: false,
//             category_counts: {
//               needs_response: emails.needs_response?.length || 0,
//               spam: emails.spam?.length || 0,
//               notify: emails.notify?.length || 0,
//             },
//           },
//         };
//       }
//     }
//   }, [emails, viewingAllAccounts]);

//   // Handle loading states with a timer to prevent UI flicker
//   useEffect(() => {
//     if (loading) {
//       // Show loading state after a short delay to prevent flickering
//       loadingTimerRef.current = setTimeout(() => {
//         setLocalLoading(true);
//       }, 300);

//       // Set fetchComplete to false when loading starts
//       fetchCompleteRef.current = false;
//     } else {
//       if (loadingTimerRef.current) {
//         clearTimeout(loadingTimerRef.current);
//       }

//       // Set fetchComplete to true when loading finishes
//       if (localLoading) {
//         fetchCompleteRef.current = true;

//         // Add a slight delay before hiding loading state to ensure smooth transitions
//         setTimeout(() => {
//           setLocalLoading(false);
//         }, 500);
//       } else {
//         setLocalLoading(false);
//       }
//     }

//     return () => {
//       if (loadingTimerRef.current) {
//         clearTimeout(loadingTimerRef.current);
//       }
//       setLocalLoading(false);
//     };
//   }, [loading]);

//   // When emails prop changes, make sure we clear loading states
//   useEffect(() => {
//     if (emails) {
//       // If we have emails data, mark fetch as complete
//       if (
//         emails.needs_response?.length > 0 ||
//         emails.spam?.length > 0 ||
//         emails.notify?.length > 0
//       ) {
//         fetchCompleteRef.current = true;

//         // Add a slight delay before hiding loading state
//         setTimeout(() => {
//           if (loadingTimerRef.current) {
//             clearTimeout(loadingTimerRef.current);
//           }
//           if (refreshTimeoutRef.current) {
//             clearTimeout(refreshTimeoutRef.current);
//           }
//           setLocalLoading(false);
//         }, 500);
//       }
//     }

//     return () => {
//       if (loadingTimerRef.current) {
//         clearTimeout(loadingTimerRef.current);
//       }
//       if (refreshTimeoutRef.current) {
//         clearTimeout(refreshTimeoutRef.current);
//       }
//       setLocalLoading(false);
//     };
//   }, [emails]);

//   // On initial mount, try to load emails from localStorage if available
//   useEffect(() => {
//     if (initialLoadRef.current) {
//       initialLoadRef.current = false;

//       // Get emails from localStorage if the current emails are empty
//       const shouldLoadFromCache =
//         !emails ||
//         (!emails.needs_response?.length &&
//           !emails.spam?.length &&
//           !emails.notify?.length);

//       if (shouldLoadFromCache) {
//         try {
//           const cachedEmails = localStorage.getItem("cached_emails");
//           if (cachedEmails) {
//             const parsedEmails = JSON.parse(cachedEmails);
//             if (
//               parsedEmails &&
//               (parsedEmails.needs_response?.length > 0 ||
//                 parsedEmails.spam?.length > 0 ||
//                 parsedEmails.notify?.length > 0)
//             ) {
//               cachedEmailsRef.current = parsedEmails;
//               setLocalLoading(false); // Ensure loading is false when using cache
//             }
//           }
//         } catch (e) {
//           console.error("Error loading emails from cache:", e);
//           setLocalLoading(false); // Ensure loading is false on error
//         }
//       }

//       // Function to check auth and fetch emails
//       const checkAuthAndFetch = () => {
//         const userId = localStorage.getItem("user_id");
//         // Also check session/cookies for user authentication
//         const isAuthenticated = document.cookie.includes("user_id=") || userId;
//         const cachedEmails = localStorage.getItem("cached_emails");
//         if (isAuthenticated && onFetchEmails && !cachedEmails) {
//           console.log("this getting called");
//           setLocalLoading(true);
//           onFetchEmails(true); // Force refresh on initial load
//           return true;
//         }
//         setLocalLoading(false); // Ensure loading is false if not authenticated
//         return false;
//       };

//       // Try immediate fetch first
//       if (!checkAuthAndFetch()) {
//         // Set up a retry mechanism
//         let retryCount = 0;
//         const maxRetries = 3;
//         const retryInterval = setInterval(() => {
//           retryCount++;

//           if (checkAuthAndFetch() || retryCount >= maxRetries) {
//             clearInterval(retryInterval);
//             if (retryCount >= maxRetries) {
//               setLocalLoading(false); // Ensure loading is false after max retries
//             }
//           }
//         }, 1000); // Try every second for 3 seconds

//         // Clean up interval on unmount
//         return () => {
//           clearInterval(retryInterval);
//           setLocalLoading(false);
//         };
//       }
//     }
//   }, [emails, onFetchEmails]);

//   // Add cleanup effect for loading states
//   useEffect(() => {
//     return () => {
//       if (loadingTimerRef.current) {
//         clearTimeout(loadingTimerRef.current);
//       }
//       if (refreshTimeoutRef.current) {
//         clearTimeout(refreshTimeoutRef.current);
//       }
//       setLocalLoading(false);
//     };
//   }, []);

//   // Update the useEffect that watches for email changes
//   useEffect(() => {
//     // If we have emails data, ensure loading states are cleared
//     if (
//       emails &&
//       (emails.needs_response?.length > 0 ||
//         emails.spam?.length > 0 ||
//         emails.notify?.length > 0)
//     ) {
//       fetchCompleteRef.current = true;

//       // Add a slight delay before hiding loading state
//       setTimeout(() => {
//         setLocalLoading(false);
//       }, 300);
//     }
//   }, [emails]);

//   // Add a global effect to monitor and reset loading state
//   useEffect(() => {
//     // Create a global tracker to monitor loading state
//     window.emailsLoadingMonitor = window.emailsLoadingMonitor || {
//       resetCount: 0,
//       startTime: null,
//     };

//     // When loading starts, update the monitor
//     if (loading || localLoading) {
//       window.emailsLoadingMonitor.startTime = Date.now();
//     }

//     // Create a periodic check to force reset loading if it gets stuck
//     const intervalCheck = setInterval(() => {
//       const monitor = window.emailsLoadingMonitor;

//       // If loading has been active for more than 20 seconds, force reset
//       if (
//         monitor.startTime &&
//         Date.now() - monitor.startTime > 20000 &&
//         (loading || localLoading)
//       ) {
//         setLocalLoading(false);
//         monitor.resetCount++;
//         monitor.startTime = null;
//       }
//     }, 5000);

//     // When emails are loaded or component unmounts, clean up
//     return () => {
//       clearInterval(intervalCheck);

//       // Reset the startTime on unmount if loading was in progress
//       if (window.emailsLoadingMonitor.startTime) {
//         window.emailsLoadingMonitor.startTime = null;
//         setLocalLoading(false);
//       }
//     };
//   }, [loading, localLoading]);

//   // Also add a specific effect to reset loading state when emails change
//   useEffect(() => {
//     const cachedEmailsData = localStorage.getItem("cached_emails");
//     if (cachedEmailsData) {
//       // If we have cached emails after loading started, reset loading
//       if (loading || localLoading) {
//         fetchCompleteRef.current = true;

//         // Add a slight delay before hiding loading state
//         setTimeout(() => {
//           setLocalLoading(false);
//         }, 300);
//       }
//     }
//   }, [emails, loading, localLoading]);

//   const formatEmailTime = (timestamp) => {
//     if (!timestamp) return "";
//     try {
//       const date = new Date(timestamp);
//       if (isNaN(date.getTime())) return "";
//       return date.toLocaleString([], {
//         year: "numeric",
//         month: "short",
//         day: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//       });
//     } catch (error) {
//       return "";
//     }
//   };

//   const getSenderName = (emailData) => {
//     if (!emailData || !emailData.email) return "Unknown";

//     if (emailData.email.display_name) return emailData.email.display_name;

//     if (emailData.email.from_name) return emailData.email.from_name;

//     if (emailData.email.from_email) {
//       const emailParts = emailData.email.from_email.split("@");
//       return emailParts[0] || "Unknown";
//     }

//     return "Unknown";
//   };

//   // Use the most up-to-date data for display, with proper account information
//   const displayEmails = useMemo(() => {
//     // During loading, continue showing existing emails
//     if (
//       localLoading &&
//       cachedEmailsRef.current &&
//       (cachedEmailsRef.current.needs_response?.length > 0 ||
//         cachedEmailsRef.current.spam?.length > 0 ||
//         cachedEmailsRef.current.notify?.length > 0)
//     ) {
//       return cachedEmailsRef.current;
//     }

//     // If current emails has data, use that
//     if (
//       emails &&
//       (emails.needs_response?.length > 0 ||
//         emails.spam?.length > 0 ||
//         emails.notify?.length > 0)
//     ) {
//       return emails;
//     }

//     // Otherwise, use cached data if available
//     return (
//       cachedEmailsRef.current || {
//         needs_response: [],
//         spam: [],
//         notify: [],
//         pagination: {
//           total_count: 0,
//           total_pages: 0,
//           has_more: false,
//           category_counts: {
//             needs_response: 0,
//             spam: 0,
//             notify: 0,
//           },
//         },
//       }
//     );
//   }, [emails, localLoading, forceUpdateCounter]); // Add forceUpdateCounter dependency

//   // Ensure proper handling of account information in current emails
//   const currentEmails = useMemo(() => {
//     const categoryEmails = displayEmails?.[activeCategory] || [];
//     if (!Array.isArray(categoryEmails)) return [];

//     // For all-accounts view, ensure account information is preserved
//     if (viewingAllAccounts) {
//       return categoryEmails.map((email) => ({
//         ...email,
//         account: email.account || null,
//       }));
//     }

//     return categoryEmails;
//   }, [displayEmails, activeCategory, viewingAllAccounts]);

//   const categoryTotalCounts = useMemo(() => {
//     if (displayEmails?.pagination?.category_counts) {
//       return {
//         needs_response:
//           displayEmails.pagination.category_counts.needs_response || 0,
//         spam: displayEmails.pagination.category_counts.spam || 0,
//         notify: displayEmails.pagination.category_counts.notify || 0,
//       };
//     }

//     return {
//       needs_response: displayEmails?.needs_response?.length || 0,
//       spam: displayEmails?.spam?.length || 0,
//       notify: displayEmails?.notify?.length || 0,
//     };
//   }, [displayEmails]);

//   const handleRefresh = useCallback(() => {
//     console.log("Refreshing emails...");
//     if (onFetchEmails && !localLoading) {
//       // Check for authentication
//       const userId = localStorage.getItem("user_id");
//       const isAuthenticated = document.cookie.includes("user_id=") || userId;

//       if (!isAuthenticated) {
//         console.warn("Cannot refresh emails - user not authenticated");
//         setLocalLoading(false);
//         return;
//       }

//       // Check if the user has already attempted to fetch emails but has none
//       const hasNoEmails =
//         localStorage.getItem("emails_fetch_attempted") === "true" &&
//         (!cachedEmailsRef.current ||
//           (cachedEmailsRef.current.needs_response?.length === 0 &&
//             cachedEmailsRef.current.spam?.length === 0 &&
//             cachedEmailsRef.current.notify?.length === 0));

//       if (hasNoEmails) {
//         const lastRefreshTime = localStorage.getItem(
//           "last_manual_refresh_time"
//         );
//         const now = Date.now();

//         if (lastRefreshTime) {
//           const lastRefresh = parseInt(lastRefreshTime, 10);
//           const timeSinceLastRefresh = now - lastRefresh;
//           if (timeSinceLastRefresh < 120000) {
//             setLocalLoading(false);
//             return;
//           }
//         }

//         localStorage.setItem("last_manual_refresh_time", now.toString());
//       }

//       // Make sure we keep current emails in cache before starting refresh
//       if (
//         !cachedEmailsRef.current ||
//         (!cachedEmailsRef.current.needs_response?.length &&
//           !cachedEmailsRef.current.spam?.length &&
//           !cachedEmailsRef.current.notify?.length)
//       ) {
//         cachedEmailsRef.current = emails;
//       }

//       // Reset fetchComplete flag and mark as loading
//       fetchCompleteRef.current = false;
//       setLocalLoading(true);

//       // Set a timeout to prevent loading getting stuck
//       refreshTimeoutRef.current = setTimeout(() => {
//         if (!fetchCompleteRef.current) {
//           console.log("Force ending loading state after timeout");
//           fetchCompleteRef.current = true;
//           setLocalLoading(false);
//         }
//       }, 15000); // 15 seconds max loading time

//       // Log that we're starting the refresh process
//       console.log("Starting email refresh process with forceRefresh=true");

//       // Step 1: Make the true request (with forceRefresh=true)
//       const trueRequest = async () => {
//         try {
//           console.log("Making TRUE request (forceRefresh=true)");
//           const response = await onFetchEmails(true);
//           console.log("TRUE request completed:", response);

//           // Process the TRUE response
//           if (response && typeof response === "object") {
//             const processedEmails = processEmailResponse(
//               response,
//               cachedEmailsRef.current
//             );
//             cachedEmailsRef.current = processedEmails;

//             // Now immediately make the FALSE request
//             return await falseRequest();
//           } else {
//             console.warn("TRUE request did not return expected data format");
//             return await falseRequest(); // Still try the FALSE request
//           }
//         } catch (error) {
//           console.error("Error in TRUE fetch emails request:", error);
//           // Even if TRUE fails, still try the FALSE request
//           return await falseRequest();
//         }
//       };

//       // Step 2: Make the false request (with forceRefresh=false)
//       const falseRequest = async () => {
//         try {
//           console.log("Making FALSE request (forceRefresh=false)");
//           const response = await onFetchEmails(false);
//           console.log("FALSE request completed:", response);

//           // Clear cached data to ensure we use the fresh data
//           localStorage.removeItem("cached_emails");
//           localStorage.removeItem("emails_last_fetch");

//           // Process the FALSE response
//           if (response && typeof response === "object") {
//             const finalProcessedEmails = processEmailResponse(
//               response,
//               cachedEmailsRef.current
//             );

//             // Store the final processed emails in localStorage
//             if (
//               finalProcessedEmails.needs_response.length > 0 ||
//               finalProcessedEmails.spam.length > 0 ||
//               finalProcessedEmails.notify.length > 0
//             ) {
//               localStorage.setItem(
//                 "cached_emails",
//                 JSON.stringify(finalProcessedEmails)
//               );
//               localStorage.setItem(
//                 "emails_last_fetch",
//                 new Date().toISOString()
//               );
//             }

//             // Update the cached emails ref with the final processed data
//             cachedEmailsRef.current = finalProcessedEmails;

//             // Force a re-render
//             setForceUpdateCounter((prev) => prev + 1);
//           }

//           return true;
//         } catch (error) {
//           console.error("Error in FALSE fetch emails request:", error);

//           // Store what we have from the TRUE request
//           if (cachedEmailsRef.current) {
//             localStorage.setItem(
//               "cached_emails",
//               JSON.stringify(cachedEmailsRef.current)
//             );
//             localStorage.setItem("emails_last_fetch", new Date().toISOString());
//           }

//           // Force a re-render to use what we have
//           setForceUpdateCounter((prev) => prev + 1);

//           return false;
//         } finally {
//           // Always mark fetch as complete and clear loading state
//           fetchCompleteRef.current = true;
//           if (refreshTimeoutRef.current) {
//             clearTimeout(refreshTimeoutRef.current);
//           }

//           // Add a slight delay before hiding loading state
//           setTimeout(() => {
//             setLocalLoading(false);
//           }, 500);
//         }
//       };

//       // Helper function to process email response data
//       const processEmailResponse = (response, cachedEmails) => {
//         const processedEmails = {
//           needs_response: Array.isArray(response.needs_response)
//             ? response.needs_response
//             : Array.isArray(cachedEmails?.needs_response)
//             ? [...cachedEmails.needs_response]
//             : [],
//           spam: Array.isArray(response.spam)
//             ? response.spam
//             : Array.isArray(cachedEmails?.spam)
//             ? [...cachedEmails.spam]
//             : [],
//           notify: Array.isArray(response.notify)
//             ? response.notify
//             : Array.isArray(cachedEmails?.notify)
//             ? [...cachedEmails.notify]
//             : [],
//           pagination: response.pagination ||
//             cachedEmails?.pagination || {
//               total_count: 0,
//               total_pages: 0,
//               has_more: false,
//               category_counts: {
//                 needs_response: 0,
//                 spam: 0,
//                 notify: 0,
//               },
//             },
//         };

//         // For all-accounts view, ensure account information is preserved
//         if (viewingAllAccounts) {
//           processedEmails.needs_response = processedEmails.needs_response.map(
//             (email) => ({
//               ...email,
//               account: email.account || null,
//             })
//           );
//           processedEmails.spam = processedEmails.spam.map((email) => ({
//             ...email,
//             account: email.account || null,
//           }));
//           processedEmails.notify = processedEmails.notify.map((email) => ({
//             ...email,
//             account: email.account || null,
//           }));
//         }

//         // Make sure counts are derived from actual data
//         if (processedEmails.pagination) {
//           processedEmails.pagination.category_counts = {
//             needs_response: processedEmails.needs_response.length,
//             spam: processedEmails.spam.length,
//             notify: processedEmails.notify.length,
//           };

//           processedEmails.pagination.total_count =
//             processedEmails.needs_response.length +
//             processedEmails.spam.length +
//             processedEmails.notify.length;
//         }

//         return processedEmails;
//       };

//       // Start the refresh process by executing the true request
//       trueRequest().catch((error) => {
//         console.error("Unhandled error in email refresh process:", error);

//         // Ensure loading states are cleared
//         fetchCompleteRef.current = true;
//         if (refreshTimeoutRef.current) {
//           clearTimeout(refreshTimeoutRef.current);
//         }
//         setLocalLoading(false);
//       });

//       // Return cleanup function
//       return () => {
//         if (refreshTimeoutRef.current) {
//           clearTimeout(refreshTimeoutRef.current);
//         }
//         setLocalLoading(false);
//       };
//     } else {
//       console.log(
//         "Skipping refresh - either onFetchEmails is not available or already loading"
//       );
//       setLocalLoading(false);
//     }
//   }, [onFetchEmails, emails, localLoading, viewingAllAccounts]);

//   // Final email loading check effect
//   useEffect(() => {
//     // If loading is active but not yet complete, we need to ensure it eventually completes
//     if ((loading || localLoading) && !fetchCompleteRef.current) {
//       // Set a timeout to force complete loading if it hasn't completed after 10 seconds
//       const forceCompleteTimeout = setTimeout(() => {
//         if (!fetchCompleteRef.current) {
//           console.log("Force completing email loading after timeout");
//           fetchCompleteRef.current = true;
//           setLocalLoading(false);
//         }
//       }, 10000);

//       return () => clearTimeout(forceCompleteTimeout);
//     }
//   }, [loading, localLoading]);

//   return (
//     <div className="flex flex-col h-full">
//       <div className="flex-1">
//         <div className="p-4">
//           <div className="max-w-4xl mx-auto">
//             <div className="bg-[#FCFCFC] px-4 shadow-sm sticky top-0 z-10 rounded-t-lg">
//               <div className="border-b border-gray-200">
//                 <nav className="flex items-center justify-between">
//                   <div className="flex space-x-4 flex-grow mr-4">
//                     <button
//                       onClick={() => {
//                         // Use onCategoryChange if setActiveCategory isn't a function
//                         if (typeof setActiveCategory === "function") {
//                           setActiveCategory("needs_response");
//                         } else if (typeof onCategoryChange === "function") {
//                           onCategoryChange("needs_response");
//                         }
//                       }}
//                       className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${
//                         activeCategory === "needs_response"
//                           ? "border-blue-500 text-blue-500"
//                           : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                       }`}
//                     >
//                       <div className="flex items-center">
//                         <svg
//                           className="h-4 w-4 mr-1 text-[#1F9BFF]"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//                           />
//                         </svg>
//                         Respond ({categoryTotalCounts.needs_response})
//                       </div>
//                     </button>
//                     <button
//                       onClick={() => {
//                         // Use onCategoryChange if setActiveCategory isn't a function
//                         if (typeof setActiveCategory === "function") {
//                           setActiveCategory("notify");
//                         } else if (typeof onCategoryChange === "function") {
//                           onCategoryChange("notify");
//                         }
//                       }}
//                       className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${
//                         activeCategory === "notify"
//                           ? "border-blue-500 text-blue-500"
//                           : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                       }`}
//                     >
//                       <div className="flex items-center">
//                         <svg
//                           className="h-4 w-4 mr-1 text-[#1F9BFF]"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
//                           />
//                         </svg>
//                         Inform ({categoryTotalCounts.notify})
//                       </div>
//                     </button>
//                     <button
//                       onClick={() => {
//                         // Use onCategoryChange if setActiveCategory isn't a function
//                         if (typeof setActiveCategory === "function") {
//                           setActiveCategory("spam");
//                         } else if (typeof onCategoryChange === "function") {
//                           onCategoryChange("spam");
//                         }
//                       }}
//                       className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${
//                         activeCategory === "spam"
//                           ? "border-blue-500 text-blue-500"
//                           : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                       }`}
//                     >
//                       <div className="flex items-center">
//                         <svg
//                           className="h-4 w-4 mr-1 text-[#1F9BFF]"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
//                           />
//                         </svg>
//                         Unimportant ({categoryTotalCounts.spam})
//                       </div>
//                     </button>
//                   </div>

//                   <div className="flex-shrink-0 min-w-10">
//                     <button
//                       className="p-2 text-gray-500 hover:text-blue-600 transition-colors duration-200"
//                       onClick={() => {
//                         // Detect if loading is already stuck
//                         const monitor = window.emailsLoadingMonitor || {};
//                         const isStuck =
//                           monitor.startTime &&
//                           Date.now() - monitor.startTime > 10000;

//                         // If loading appears to be stuck, force reset it
//                         if (isStuck) {
//                           monitor.resetCount = (monitor.resetCount || 0) + 1;
//                           monitor.startTime = null;
//                         }

//                         // Always reset loading state before starting a new refresh
//                         setLocalLoading(false);

//                         // Set a flag in localStorage to track when the refresh started
//                         localStorage.setItem(
//                           "email_refresh_start_time",
//                           Date.now().toString()
//                         );

//                         // Call the refresh handler
//                         handleRefresh();
//                       }}
//                       disabled={localLoading || loading}
//                       type="button"
//                     >
//                       {localLoading || loading ? (
//                         <svg
//                           className="animate-spin h-5 w-5"
//                           xmlns="http://www.w3.org/2000/svg"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                         >
//                           <circle
//                             className="opacity-25"
//                             cx="12"
//                             cy="12"
//                             r="10"
//                             stroke="currentColor"
//                             strokeWidth="4"
//                           ></circle>
//                           <path
//                             className="opacity-75"
//                             fill="currentColor"
//                             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                           ></path>
//                         </svg>
//                       ) : (
//                         <div className="flex items-center gap-2">
//                           <span className="text-sm">Refresh Emails</span>
//                           <svg
//                             className="w-5 h-5"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//                             ></path>
//                           </svg>
//                         </div>
//                       )}
//                     </button>
//                   </div>
//                 </nav>
//               </div>
//             </div>

//             {/* Email list with max height and vertical scroll */}
//             <div className="bg-[#FCFCFC] shadow max-h-[calc(100vh-60vh)] min-h-[calc(100vh-80vh)] overflow-y-auto flex flex-col">
//               <div className="divide-y divide-gray-200 flex-1 flex flex-col">
//                 {localLoading && currentEmails.length === 0 ? (
//                   <div className="p-4 text-center flex flex-col items-center justify-center flex-1 space-y-3">
//                     <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
//                     <div className="text-gray-500">Loading emails... </div>
//                     <div className="text-xs text-gray-400">
//                       {viewingAllAccounts
//                         ? "Fetching from all connected accounts"
//                         : "Fetching from current account"}
//                     </div>
//                   </div>
//                 ) : error ? (
//                   <div className="p-4 text-center text-red-500 flex items-center justify-center flex-1">
//                     {error}
//                   </div>
//                 ) : currentEmails.length === 0 ? (
//                   <div className="p-4 text-center text-gray-500 flex items-center justify-center flex-1">
//                     No emails in this category
//                     {viewingAllAccounts && (
//                       <span className="ml-1">from any account</span>
//                     )}
//                   </div>
//                 ) : (
//                   currentEmails.map((emailData) => (
//                     <div
//                       key={emailData.email.id}
//                       onClick={() => onEmailSelect(emailData)}
//                       className="h-12 py-2 px-2 hover:bg-white hover:shadow-lg cursor-pointer group transition-colors duration-200 ease-in-out overflow-hidden"
//                     >
//                       <div className="flex items-center justify-between h-full w-full">
//                         <div className="flex items-center flex-grow min-w-0">
//                           <input
//                             type="checkbox"
//                             className="mr-3 h-4 w-4 text-blue-600 rounded transition-colors duration-200"
//                             onClick={(e) => e.stopPropagation()}
//                           />

//                           <button
//                             className="mr-3 text-gray-400 hover:text-yellow-500 transition-colors duration-200 flex-shrink-0"
//                             onClick={(e) => e.stopPropagation()}
//                           >
//                             <svg
//                               className="h-4 w-4"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
//                               />
//                             </svg>
//                           </button>

//                           <div
//                             className="min-w-0 flex-1 flex items-center overflow-hidden"
//                             onClick={(e) => e.stopPropagation()}
//                           >
//                             <span className="text-sm font-medium mr-2 truncate max-w-[150px] flex-shrink-0">
//                               {getSenderName(emailData)}
//                             </span>
//                             <span className="text-sm text-gray-600 truncate">
//                               {emailData.email?.subject || "No subject"}
//                             </span>

//                             {viewingAllAccounts && emailData.account && (
//                               <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-700 whitespace-nowrap">
//                                 {emailData.account.provider === "google" ? (
//                                   <span className="flex items-center">
//                                     <img
//                                       src="https://www.google.com/favicon.ico"
//                                       alt="Google"
//                                       className="w-3 h-3 mr-1"
//                                     />
//                                     {emailData.account.email.split("@")[0]}
//                                   </span>
//                                 ) : emailData.account.provider === "outlook" ? (
//                                   <span className="flex items-center">
//                                     <img
//                                       src="https://www.microsoft.com/favicon.ico"
//                                       alt="Outlook"
//                                       className="w-3 h-3 mr-1"
//                                     />
//                                     {emailData.account.email.split("@")[0]}
//                                   </span>
//                                 ) : (
//                                   emailData.account.email.split("@")[0]
//                                 )}
//                               </span>
//                             )}
//                           </div>
//                         </div>

//                         <div className="flex items-center space-x-2 flex-shrink-0">
//                           <span className="text-xs text-gray-500 w-20 text-right group-hover:hidden transition-opacity duration-200">
//                             {(() => {
//                               try {
//                                 const now = new Date();
//                                 const sendTime = new Date(
//                                   emailData.email.send_time
//                                 );
//                                 if (isNaN(sendTime.getTime())) return "";

//                                 const diffInSeconds = Math.floor(
//                                   (now - sendTime) / 1000
//                                 );

//                                 if (diffInSeconds < 60) return "just now";
//                                 if (diffInSeconds < 3600)
//                                   return `${Math.floor(
//                                     diffInSeconds / 60
//                                   )}m ago`;
//                                 if (diffInSeconds < 86400)
//                                   return `${Math.floor(
//                                     diffInSeconds / 3600
//                                   )}h ago`;
//                                 if (diffInSeconds < 604800)
//                                   return `${Math.floor(
//                                     diffInSeconds / 86400
//                                   )}d ago`;
//                                 if (diffInSeconds < 2592000)
//                                   return `${Math.floor(
//                                     diffInSeconds / 604800
//                                   )}w ago`;
//                                 if (diffInSeconds < 31536000)
//                                   return `${Math.floor(
//                                     diffInSeconds / 2592000
//                                   )}mo ago`;
//                                 return `${Math.floor(
//                                   diffInSeconds / 31536000
//                                 )}y ago`;
//                               } catch (e) {
//                                 return "";
//                               }
//                             })()}
//                           </span>

//                           {/* Action Buttons - Only show on hover */}
//                           <div className="hidden group-hover:flex space-x-1">
//                             <button
//                               className="p-1 text-gray-400 hover:text-red-500 transition-colors duration-200"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 if (onDelete) {
//                                   setDeletingId(emailData.email.id);
//                                   onDelete(emailData.email.id)
//                                     .then(() => {
//                                       setDeletingId(null);
//                                     })
//                                     .catch(() => {
//                                       setDeletingId(null);
//                                     });
//                                 }
//                               }}
//                             >
//                               {deletingId === emailData.email.id ? (
//                                 <svg
//                                   className="animate-spin h-4 w-4"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   fill="none"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <circle
//                                     className="opacity-25"
//                                     cx="12"
//                                     cy="12"
//                                     r="10"
//                                     stroke="currentColor"
//                                     strokeWidth="4"
//                                   ></circle>
//                                   <path
//                                     className="opacity-75"
//                                     fill="currentColor"
//                                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                   ></path>
//                                 </svg>
//                               ) : (
//                                 <svg
//                                   className="h-4 w-4"
//                                   fill="none"
//                                   stroke="currentColor"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                                   />
//                                 </svg>
//                               )}
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 )}

//                 {/* Show loading indicator when refreshing */}
//                 {(localLoading || loading) && currentEmails.length > 0 && (
//                   <div className="p-2 text-center">
//                     <span className="inline-block animate-pulse bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs">
//                       Refreshing emails...
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Footer with info (removed pagination) */}
//             <div className="bg-white shadow-sm py-3 px-4 rounded-b-lg flex justify-between items-center">
//               <div className="text-xs text-gray-500">
//                 {currentEmails.length > 0
//                   ? `Showing ${currentEmails.length} email${
//                       currentEmails.length !== 1 ? "s" : ""
//                     }`
//                   : "No emails to display"}
//               </div>

//               <div className="text-xs text-gray-500">
//                 Last updated:{" "}
//                 {localStorage.getItem("emails_last_fetch")
//                   ? new Date(
//                       localStorage.getItem("emails_last_fetch")
//                     ).toLocaleTimeString()
//                   : "Never"}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Emails;

import React, { useMemo, useEffect, useState, useRef } from "react";

const Emails = ({
  emails = {
    needs_response: [],
    spam: [],
    notify: [],
    pagination: {
      total_count: 0,
      total_pages: 0,
      has_more: false,
      category_counts: {
        needs_response: 0,
        spam: 0,
        notify: 0,
      },
    },
  },
  activeCategory,
  loading,
  error,
  progress = 0, // Get progress from context instead
  setActiveCategory,
  onEmailSelect,
  onCategoryChange,
  onDelete,
  email,
  viewingAllAccounts = false,
}) => {
  const [deletingId, setDeletingId] = useState(null);
  const [forceUpdateCounter, setForceUpdateCounter] = useState(0);

  // Cached emails ref to prevent flickering during loading
  const cachedEmailsRef = useRef(emails);

  // Update cached ref when new emails arrive and ensure proper handling of all-accounts data
  useEffect(() => {
    // Only update cache if emails is not empty and has valid data
    if (
      emails &&
      (emails.needs_response?.length >= 0 ||
        emails.spam?.length >= 0 ||
        emails.notify?.length >= 0)
    ) {
      // For all-accounts view, ensure we preserve account information
      if (viewingAllAccounts) {
        const validatedEmails = {
          ...emails,
          needs_response:
            emails.needs_response?.map((email) => ({
              ...email,
              account: email.account || null,
            })) || [],
          spam:
            emails.spam?.map((email) => ({
              ...email,
              account: email.account || null,
            })) || [],
          notify:
            emails.notify?.map((email) => ({
              ...email,
              account: email.account || null,
            })) || [],
          pagination: emails.pagination || {
            total_count: 0,
            total_pages: 0,
            has_more: false,
            category_counts: {
              needs_response: emails.needs_response?.length || 0,
              spam: emails.spam?.length || 0,
              notify: emails.notify?.length || 0,
            },
          },
        };
        cachedEmailsRef.current = validatedEmails;
      } else {
        cachedEmailsRef.current = {
          ...emails,
          pagination: emails.pagination || {
            total_count: 0,
            total_pages: 0,
            has_more: false,
            category_counts: {
              needs_response: emails.needs_response?.length || 0,
              spam: emails.spam?.length || 0,
              notify: emails.notify?.length || 0,
            },
          },
        };
      }
    }
  }, [emails, viewingAllAccounts]);

  const formatEmailTime = (timestamp) => {
    if (!timestamp) return "";
    try {
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return "";
      return date.toLocaleString([], {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      return "";
    }
  };

  const getSenderName = (emailData) => {
    if (!emailData || !emailData.email) return "Unknown";

    if (emailData.email.display_name) return emailData.email.display_name;

    if (emailData.email.from_name) return emailData.email.from_name;

    if (emailData.email.from_email) {
      const emailParts = emailData.email.from_email.split("@");
      return emailParts[0] || "Unknown";
    }

    return "Unknown";
  };

  // Use the most up-to-date data for display, with proper account information
  const displayEmails = useMemo(() => {
    // If current emails has data, use that
    if (
      emails &&
      (emails.needs_response?.length > 0 ||
        emails.spam?.length > 0 ||
        emails.notify?.length > 0)
    ) {
      return emails;
    }

    // Otherwise, use cached data if available
    return (
      cachedEmailsRef.current || {
        needs_response: [],
        spam: [],
        notify: [],
        pagination: {
          total_count: 0,
          total_pages: 0,
          has_more: false,
          category_counts: {
            needs_response: 0,
            spam: 0,
            notify: 0,
          },
        },
      }
    );
  }, [emails, forceUpdateCounter]);

  // Ensure proper handling of account information in current emails
  const currentEmails = useMemo(() => {
    const categoryEmails = displayEmails?.[activeCategory] || [];
    if (!Array.isArray(categoryEmails)) return [];

    // Filter out any invalid email data and ensure proper structure
    return categoryEmails
      .filter((emailData) => emailData && emailData.email && emailData.email.id)
      .map((email) => {
        // For all-accounts view, ensure account information is preserved
        if (viewingAllAccounts) {
          return {
            ...email,
            account: email.account || null,
          };
        }
        return email;
      });
  }, [displayEmails, activeCategory, viewingAllAccounts]);

  const categoryTotalCounts = useMemo(() => {
    if (displayEmails?.pagination?.category_counts) {
      return {
        needs_response:
          displayEmails.pagination.category_counts.needs_response || 0,
        spam: displayEmails.pagination.category_counts.spam || 0,
        notify: displayEmails.pagination.category_counts.notify || 0,
      };
    }

    return {
      needs_response: displayEmails?.needs_response?.length || 0,
      spam: displayEmails?.spam?.length || 0,
      notify: displayEmails?.notify?.length || 0,
    };
  }, [displayEmails]);

  // Progress Circle Component
  const ProgressCircle = ({ progress }) => {
    const radius = 10;
    const strokeWidth = 2;
    const normalizedRadius = radius - strokeWidth * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDasharray = `${circumference} ${circumference}`;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
      <div className="flex items-center gap-2">
        <svg
          height={radius * 2}
          width={radius * 2}
          className="transform -rotate-90"
        >
          <circle
            stroke="#e5e7eb"
            fill="transparent"
            strokeWidth={strokeWidth}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            stroke="#3b82f6"
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            style={{ strokeDashoffset }}
            strokeLinecap="round"
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        <span className="text-sm text-gray-600">
          Loading... {Math.round(progress)}%
        </span>
      </div>
    );
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1">
        <div className="p-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-[#FCFCFC] px-4 shadow-sm sticky top-0 z-10 rounded-t-lg">
              <div className="border-b border-gray-200">
                <nav className="flex items-center justify-between">
                  <div className="flex space-x-4 flex-grow mr-4">
                    <button
                      onClick={() => {
                        // Use onCategoryChange if setActiveCategory isn't a function
                        if (typeof setActiveCategory === "function") {
                          setActiveCategory("needs_response");
                        } else if (typeof onCategoryChange === "function") {
                          onCategoryChange("needs_response");
                        }
                      }}
                      className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${
                        activeCategory === "needs_response"
                          ? "border-blue-500 text-blue-500"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`}
                    >
                      <div className="flex items-center">
                        <svg
                          className="h-4 w-4 mr-1 text-[#1F9BFF]"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                        Respond ({categoryTotalCounts.needs_response})
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        // Use onCategoryChange if setActiveCategory isn't a function
                        if (typeof setActiveCategory === "function") {
                          setActiveCategory("notify");
                        } else if (typeof onCategoryChange === "function") {
                          onCategoryChange("notify");
                        }
                      }}
                      className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${
                        activeCategory === "notify"
                          ? "border-blue-500 text-blue-500"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`}
                    >
                      <div className="flex items-center">
                        <svg
                          className="h-4 w-4 mr-1 text-[#1F9BFF]"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                          />
                        </svg>
                        Inform ({categoryTotalCounts.notify})
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        // Use onCategoryChange if setActiveCategory isn't a function
                        if (typeof setActiveCategory === "function") {
                          setActiveCategory("spam");
                        } else if (typeof onCategoryChange === "function") {
                          onCategoryChange("spam");
                        }
                      }}
                      className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${
                        activeCategory === "spam"
                          ? "border-blue-500 text-blue-500"
                          : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                      }`}
                    >
                      <div className="flex items-center">
                        <svg
                          className="h-4 w-4 mr-1 text-[#1F9BFF]"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                          />
                        </svg>
                        Unimportant ({categoryTotalCounts.spam})
                      </div>
                    </button>
                  </div>

                  <div className="flex-shrink-0 min-w-10">
                    {loading ? (
                      <div className="p-2">
                        <ProgressCircle progress={progress} />
                      </div>
                    ) : null}
                  </div>
                </nav>
              </div>
            </div>

            {/* Email list with max height and vertical scroll */}
            <div className="bg-[#FCFCFC] shadow max-h-[calc(100vh-60vh)] min-h-[calc(100vh-80vh)] overflow-y-auto flex flex-col">
              <div className="divide-y divide-gray-200 flex-1 flex flex-col">
                {loading && currentEmails.length === 0 ? (
                  <div className="p-4 text-center flex flex-col items-center justify-center flex-1 space-y-3">
                    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
                    <div className="text-gray-500">Loading emails... </div>
                    <div className="text-xs text-gray-400">
                      {viewingAllAccounts
                        ? "Fetching from all connected accounts"
                        : "Fetching from current account"}
                    </div>
                  </div>
                ) : error ? (
                  <div className="p-4 text-center text-gray-500 flex items-center justify-center flex-1">
                    Establishing Connection
                  </div>
                ) : currentEmails.length === 0 ? (
                  <div className="p-4 text-center text-gray-500 flex items-center justify-center flex-1">
                    No emails in this category
                    {viewingAllAccounts && (
                      <span className="ml-1">from any account</span>
                    )}
                  </div>
                ) : (
                  currentEmails.map((emailData) => (
                    <div
                      key={emailData.email.id}
                      onClick={() => onEmailSelect(emailData)}
                      className="h-12 py-2 px-2 hover:bg-white hover:shadow-lg cursor-pointer group transition-colors duration-200 ease-in-out overflow-hidden"
                    >
                      <div className="flex items-center justify-between h-full w-full">
                        <div className="flex items-center flex-grow min-w-0">
                          <input
                            type="checkbox"
                            className="mr-3 h-4 w-4 text-blue-600 rounded transition-colors duration-200"
                            onClick={(e) => e.stopPropagation()}
                          />

                          <button
                            className="mr-3 text-gray-400 hover:text-yellow-500 transition-colors duration-200 flex-shrink-0"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <svg
                              className="h-4 w-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                              />
                            </svg>
                          </button>

                          <div className="min-w-0 flex-1 flex items-center overflow-hidden">
                            <span className="text-sm font-medium mr-2 truncate max-w-[150px] flex-shrink-0">
                              {getSenderName(emailData)}
                            </span>
                            <span className="text-sm text-gray-600 truncate">
                              {emailData.email?.subject || "No subject"}
                            </span>

                            {viewingAllAccounts && emailData.account && (
                              <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-blue-100 text-blue-700 whitespace-nowrap">
                                {emailData.account.provider === "google" ||
                                emailData.account.provider === "gmail" ? (
                                  <span className="flex items-center">
                                    <img
                                      src="https://www.google.com/favicon.ico"
                                      alt="Google"
                                      className="w-3 h-3 mr-1"
                                    />
                                    {emailData.account.email?.split("@")[0] ||
                                      "Unknown"}
                                  </span>
                                ) : emailData.account.provider === "outlook" ? (
                                  <span className="flex items-center">
                                    <img
                                      src="https://www.microsoft.com/favicon.ico"
                                      alt="Outlook"
                                      className="w-3 h-3 mr-1"
                                    />
                                    {emailData.account.email?.split("@")[0] ||
                                      "Unknown"}
                                  </span>
                                ) : (
                                  emailData.account.email?.split("@")[0] ||
                                  "Unknown"
                                )}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="flex items-center space-x-2 flex-shrink-0">
                          <span className="text-xs text-gray-500 w-20 text-right group-hover:hidden transition-opacity duration-200">
                            {(() => {
                              try {
                                if (!emailData.email?.send_time) return "";

                                const now = new Date();
                                const sendTime = new Date(
                                  emailData.email.send_time
                                );
                                if (isNaN(sendTime.getTime())) return "";

                                const diffInSeconds = Math.floor(
                                  (now - sendTime) / 1000
                                );

                                if (diffInSeconds < 60) return "just now";
                                if (diffInSeconds < 3600)
                                  return `${Math.floor(
                                    diffInSeconds / 60
                                  )}m ago`;
                                if (diffInSeconds < 86400)
                                  return `${Math.floor(
                                    diffInSeconds / 3600
                                  )}h ago`;
                                if (diffInSeconds < 604800)
                                  return `${Math.floor(
                                    diffInSeconds / 86400
                                  )}d ago`;
                                if (diffInSeconds < 2592000)
                                  return `${Math.floor(
                                    diffInSeconds / 604800
                                  )}w ago`;
                                if (diffInSeconds < 31536000)
                                  return `${Math.floor(
                                    diffInSeconds / 2592000
                                  )}mo ago`;
                                return `${Math.floor(
                                  diffInSeconds / 31536000
                                )}y ago`;
                              } catch (e) {
                                return "";
                              }
                            })()}
                          </span>

                          {/* Action Buttons - Only show on hover */}
                          <div className="hidden group-hover:flex space-x-1">
                            <button
                              className="p-1 text-gray-400 hover:text-red-500 transition-colors duration-200"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (onDelete && emailData.email?.id) {
                                  setDeletingId(emailData.email.id);
                                  onDelete(emailData.email.id)
                                    .then(() => {
                                      setDeletingId(null);
                                    })
                                    .catch(() => {
                                      setDeletingId(null);
                                    });
                                }
                              }}
                            >
                              {deletingId === emailData.email?.id ? (
                                <svg
                                  className="animate-spin h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                              ) : (
                                <svg
                                  className="h-4 w-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                  />
                                </svg>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}

                {/* Show loading indicator when refreshing */}
                {loading && currentEmails.length > 0 && (
                  <div className="p-2 text-center">
                    <span className="inline-block animate-pulse bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs">
                      Refreshing emails...
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* Footer with info (removed pagination) */}
            <div className="bg-white shadow-sm py-3 px-4 rounded-b-lg flex justify-between items-center">
              <div className="text-xs text-gray-500">
                {currentEmails.length > 0
                  ? `Showing ${currentEmails.length} email${
                      currentEmails.length !== 1 ? "s" : ""
                    }`
                  : "No emails to display"}
              </div>

              <div className="text-xs text-gray-500">
                Last updated:{" "}
                {localStorage.getItem("emails_last_fetch")
                  ? new Date(
                      localStorage.getItem("emails_last_fetch")
                    ).toLocaleTimeString()
                  : "Never"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Emails;
